module.exports = {"320706001":"朐阳街道","320706006":"新海街道","320706009":"云台街道","320706010":"新浦街道","320706011":"海州街道","320706012":"幸福路街道","320706013":"洪门街道","320706014":"宁海街道","320706016":"浦西街道","320706017":"新东街道","320706018":"新南街道","320706019":"路南街道","320706020":"花果山街道","320706021":"南城街道","320706022":"郁州街道","320706100":"锦屏镇","320706102":"新坝镇","320706103":"板浦镇","320706104":"浦南镇","320706402":"岗埠农场","320706403":"新浦经济开发区","320706404":"海州经济开发区","320706405":"高新技术开发区","320706406":"云台农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320706.json
// module id = 986
// module chunks = 0